<template>
    <div id="sign-mifiel-contracts">
        <vx-card v-if="isSigning" title="¡Firma tus contratos!">
            <div id="here-to-sign"></div>
        </vx-card>
        <div v-else-if="isSuccess" class="vx-row no-gutter items-center justify-center">
            <div class="vx-col sm:w-5/6 md:w-2/3 lg:w-1/2 xl:w-2/5 xxl:w-1/3">
                <vx-card class="vx-row no-gutter items-center justify-center p-6">
                    <h5 class="mb-2">
                        Ya has firmado el contrato. Una vez que todas las partes hayan firmado el contrato, podrás consultarlo en tu portal iniciando sesión. Si tienes alguna duda puedes contarnos a través del Chat. Gracias por confiar en RedGirasol.
                    </h5>
                    <vs-button @click.stop="backToLogin" class="mt-2">Iniciar sesión</vs-button>
                </vx-card>
            </div>
        </div>
        <div v-else-if="isError" class="vx-row no-gutter items-center justify-center">
            <div class="vx-col sm:w-5/6 md:w-2/3 lg:w-1/2 xl:w-2/5 xxl:w-1/3">
                <vx-card class="vx-row no-gutter items-center justify-center p-6">
                    <h5 class="mb-2">
                        No pudimos cargar el documento para firma.
                    </h5>
                    <p class="mb-2">
                        Abre esta misma liga en una ventana de incógnito o en otro navegador. Si el problema continúa, contáctanos a través del Chat para continuar con tu proceso.
                    </p>
                    <vs-button @click.stop="backToLogin" class="mt-2">Iniciar sesión</vs-button>
                </vx-card>
            </div>
        </div>
    </div>
</template>

<script>
import alerts from "@mixins/alerts.js"

const MIFIEL_WIDGET_URL = 'https://www.mifiel.com/sign-widget-v1.0.0.js';

// Con 'anonymous' el navegador no envía cookies de mifiel.com al pedir el script,
// lo que evita el ciclo de redirecciones (ERR_TOO_MANY_REDIRECTS).
// IMPORTANTE: solo funciona si MiFiel responde con Access-Control-Allow-Origin.
// Si no lo hace, cambia este valor a null o el script fallará para todos.
const MIFIEL_SCRIPT_CROSSORIGIN = 'anonymous';

export default {
    name: "SignMiFielContractsLanding",
    mixins: [alerts],
    data() {
        return {
            ticket: null,
            reqId: null,
            isSuccess: false,
            isError: false,
            isSigning: true
        }
    },
    async mounted() {
        const params = new URLSearchParams(window.location.search);
        this.ticket = params.get('ticket');
        this.reqId = params.get('reqId');

        if (!this.ticket) {
            this.showError();
            return;
        }

        try {
            await this.loadMifielScript();
            this.setUpWidget(this.ticket);
        } catch (e) {
            console.error('[MiFiel] No se pudo cargar o inicializar el widget', {
                reqId: this.reqId,
                error: e
            });
            this.showError();
        }
    },
    methods: {
        loadMifielScript() {
            if (window.mifiel && typeof window.mifiel.widget === 'function') {
                return Promise.resolve();
            }

            return new Promise((resolve, reject) => {
                const existing = document.querySelector(`script[src="${MIFIEL_WIDGET_URL}"]`);
                if (existing) {
                    existing.addEventListener('load', resolve);
                    existing.addEventListener('error', () => reject(new Error('Error al cargar el script de MiFiel')));
                    return;
                }

                const script = document.createElement('script');
                script.src = MIFIEL_WIDGET_URL;
                script.async = true;
                if (MIFIEL_SCRIPT_CROSSORIGIN) {
                    script.crossOrigin = MIFIEL_SCRIPT_CROSSORIGIN;
                }
                script.onload = () => {
                    if (window.mifiel && typeof window.mifiel.widget === 'function') {
                        resolve();
                    } else {
                        reject(new Error('El script de MiFiel cargó pero window.mifiel no está disponible'));
                    }
                };
                // Aquí cae el ERR_TOO_MANY_REDIRECTS o cualquier falla de red/CORS
                script.onerror = () => reject(new Error('Error al cargar el script de MiFiel'));
                document.head.appendChild(script);
            });
        },
        setUpWidget(ticket) {
            window.mifiel.widget({
                widgetId: ticket,
                appendTo: 'here-to-sign',
                successBtnText: 'Continuar',
                onSuccess: {
                    // Arrow function para que `this` sea el componente
                    callToAction: () => {
                        this.isSigning = false;
                        this.isSuccess = true;
                        this.saveSuccessNotif(null, "Se ha firmado el contrato de manera correcta, recibirás más información sobre tu proceso a través de un ejecutivo de cuenta de RedGirasol. Puedes cerrar esta página.");
                    },
                },
                onError: {
                    callToAction: () => {
                        this.showError();
                        this.missingFieldsNotif(null, "Hemos tenido problemas para continuar con tu proceso de firma, por favor ponte en contacto con nuestro equipo de soporte a través del chat.");
                    },
                },
            });
        },
        showError() {
            this.isSigning = false;
            this.isSuccess = false;
            this.isError = true;
        }
    }
}
</script>

<style scoped>

</style>